module.exports = __webpack_public_path__ + "static/img/bind_logo.dddf993.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bind_logo.png
// module id = u+4g
// module chunks = 5